import { registerSessionCacheClearHandler } from '../../shared/ports/sessionResetPort';
import { resetMastersSyncPolicyOnLogout } from '../core/masterSyncPolicy';

registerSessionCacheClearHandler(() => {
  resetMastersSyncPolicyOnLogout();
});
